import axios from "axios";
// const auth = localStorage.getItem("auth_token");

// import qs from "qs";
// export const restoreDelGroupingApiHandler = async (params) => {
//   const toArray = (value) => {
//     if (Array.isArray(value)) return value;
//     if (!value) return [];
//     if (typeof value === "string") {
//       let v = value.trim();
//       if (v.startsWith("[") && v.endsWith("]")) {
//         v = v.slice(1, -1);
//       }
//       return v.split(",").map(x => x.replace(/"/g, "").trim());
//     }
//     return [String(value)];
//   };
//   const idsArray = toArray(params.deletedGroupingID);
//   const joined = idsArray.join(",");
//   return await axios.put(
//     `/api/v1/groupingTemplate/restoreDeletedGrouping`,
//     {},
//     {
//       headers,
//       params,
//       paramsSerializer: () => {
//         return `groupingTemplateID=${params.groupingTemplateID}&deletedGroupingID=[${joined}]`;
//       }
//     }
//   );
// };

const getToken = () => {
    return localStorage.getItem("auth_token");
}
const headers = {
  "x-auth-token": getToken(),
};

export const state = async () => {
    return axios.get(`api/v1/seeder/get-state`)
}
export const country = async () => {
    return axios.get(`api/v1/seeder/get-county`)
}
export const cities = async () => {
    return axios.get(`api/v1/seeder/get-cities`)
}

export const signupV2 = async (data) => {
    return axios.post(`api/v1/auth/signupV2`, data)
}

export const VerifyOtp = async (data) => {
    return axios.post(`api/v1/auth/send-otp`, data)
}

export const getCompany = async () => {
    return axios.get(`api/v1/company/get-comapny`, { headers })
}

export const resetPassword = async (data) => {
    return axios.post(`api/v1/superadmin/resetpassword`, data)
}

export const createNewPassword = async (data) => {
    return axios.post(`api/v1/superadmin/createpassword`, data)
}

export const emailverification = async (data) => {
    return axios.post(`api/v1/auth/verify-email`, data)
}

export const multiCompany = async (data) => {
    return axios.post(`api/v1/company/multiple-company`, data, { headers })
}

export const getWorkspaceMultiCompany = async () => {
    return axios.get(`api/v1/company/get-multipleCompany`, { headers })
}

export const createCompany = async (data) => {
    return axios.post('api/v1/company/create-company', data, { headers })
}

export const CreateWorkspace = async (data) => {
    return axios.post('api/v1/workspace/create-workspace', data, { headers })
}

export const createWorkspaceName = async (w_id, data) => {
    return axios.post(`api/v1/workspace/update-workspaceName/${w_id}`, data, { headers })
}
export const UpdateStepStatus = async (w_id, data) => {
    return axios.post(`api/v1/workspace/update-status/${w_id}`, data, { headers })
}

export const CreateIr = async (data) => {
    return axios.post(`api/v1/workspace/set-allCheckedIr`, data, { headers })
}

export const CreateCompany = async (data) => {
    return axios.post(`api/v1/workspace/set-allCheckedCompany`, data, { headers })
}
export const CreatePresetCheck = async (data) => {
    return axios.post(`api/v1/workspace/set-allCheckedPreset`, data, { headers })
}

export const CreateBookClosurePresetCheck = async (data) => {
    return axios.post(`api/v1/workspace/set-allCheckedBookClosurePreset`, data, { headers })
}

export const GetCheckedIR = async (wid) => {
    return axios.get(`api/v1/workspace/get-checkedIR/${wid}`, { headers })
}

export const GetUser = async (data) => {
    return axios.get(`api/v1/auth/all-user`, { headers })
}

export const CreateAccess = async (data) => {
    return axios.post(`api/v1/workspace/set-userAccess`, data, { headers })
}

export const GetAccess = async (data) => {
    return axios.get(`api/v1/workspace/all-Access`, { headers })
}

export const GetAllCompany = async () => {
    return axios.get(`api/v1/company/get-allCompany`, { headers })
}

export const GetAllCompanyData = async () => {
    return axios.get(`api/v1/company/get-allCompanyData`, { headers })
}



export const GetAllProject = async (w_id) => {
    return axios.get(`api/v1/project/get-project/${w_id}`, { headers })

}

export const GetTeamAccess = async () => {
    return axios.get(`api/v1/workspace/all-Access`, { headers })
}

export const getAllIR = () => {
  return axios.get("api/v1/company-data/all-IR", {
    headers,
  });
};

export const getAllInvestRegister = () => {
  return axios.get("api/v1/company-data/allInvestRegister", {
    headers,
  });
};

export const getRegisterInvest = (ir_id) => {
  return axios.get(`api/v1/company-data/all-register/${ir_id}`, {
    headers,
  });
};

export const getAllWorkspace = () => {
  return axios.get("api/v1/workspace/all-workspace", {
    headers,
  });
};
export const AllWorkspace = () => {
    return axios.get('api/v1/workspace/workspace', {
        headers
    })
}
export const getWorkspace = (W_id) => {
    return axios.get(`api/v1/workspace/get-Oneworkspace/${W_id}`, {
        headers
    })
}
export const accessWorkspacedata = () => {
    return axios.get(`api/v1/workspace/get-accessWorkspace`, {
        headers
    })
}
export const getOneAccessWorkspacedata = (wid) => {
    return axios.get(`api/v1/workspace/get-OneAcessworkspace/${wid}`, {
        headers
    })
}

export const deleteIr = (Ir_id) => {
    return axios.get(`api/v1/company-data/delete-Ir/${Ir_id}`, {
        headers
    })
}

export const saveFsData = (data) => {
    return axios.post(`api/v1/prepare-consol/create-fsGroup`, data, { headers })
}

export const updateFsData = (p_id, data) => {
    return axios.post(`api/v1/prepare-consol/update-preConsol-data/${p_id}`, data, { headers })
}


export const deleteControlFS = (fs_id) => {
    return axios.get(`api/v1/prepare-consol/delete-prepare-console/${fs_id}`, {
        headers
    })
}

export const WorkspaceUpdate = async (data, w_id) => {
    return axios.post(`api/v1/workspace/update-workspace/${w_id}`, data, { headers })
}

export const DuplicateWorkspace = async (w_id) => {
    return axios.post(`api/v1/workspace/duplicate-workspace/${w_id}`, { headers })
}

export const getCheckData = (w_id) => {
    return axios.get(`api/v1/workspace/get-checkedIR/${w_id}`, {
        headers
    })
}

export const findCompanyData = (c_id) => {
    return axios.get(`api/v1/company/get-onecomapny/${c_id}`, {
        headers
    })
}

export const TeamMember = (w_id) => {
    return axios.get(`api/v1/workspace/get-member/${w_id}`, {
        headers
    })
}

export const GetProject = async () => {
    return axios.get(`api/v1/project/get-project`, { headers })

}

export const getStandaloneFS = async (p_id) => {
    return axios.get(`api/v1/grouping/fs-data/${p_id}`, { headers })

}

export const saveRolePermission = async (data) => {
    return axios.post(`/api/v1/rolePermission/save-role`, data, { headers })
}

export const getRolePermission = async () => {
    return axios.get(`/api/v1/rolePermission/get-role`, { headers })
}

export const saveUserData = async (data) => {
    return axios.post(`/api/v1/auth/save-member`, data, { headers })
}

export const getMeber = async () => {
    return axios.get(`/api/v1/auth/all-member`, { headers })
}

export const getMemberForFreePlans = async () => {
    return axios.get(`/api/v1/auth/all-member-for-freeplan`, { headers })
}

// export const saveDeletedMembers = async (data) => {
//         return axios.post(`/api/v1/deleted-users/save-deleted-members`,data,{headers})
// }

export const getDeletedMembers = async () => {
    return axios.get(`/api/v1/auth/fetch-deleted-members`, { headers })
}

export const deleteRoleData = async (r_id) => {
    return axios.get(`/api/v1/rolePermission/delete-role/${r_id}`, { headers })
}
export const deleteUserData = async (u_id) => {
    return axios.get(`/api/v1/auth/delete-member/${u_id}`, { headers })
}

export const deleteRestoreData = async (u_id) => {
    return axios.get(`/api/v1/auth/delete-restore-members/${u_id}`, { headers })
}

export const deleteCompanyData = async (c_id, data) => {
    return axios.post(`/api/v1/company/delete-comapny/${c_id}`, data, { headers })
}


export const deleteWorkspace = async (w_id) => {
    return axios.get(`/api/v1/workspace/deleteWorkspace/${w_id}`, { headers })
}

export const editCompanyData = async (c_id, data) => {
    return axios.post(`/api/v1/company/edit-company/${c_id}`, data, { headers })
}

export const fetchCoa = async () => {
    return axios.get(`/api/v1/fs-classification/get-coa`, { headers })
}

export const fetchCoaById = async (w_id) => {
    return axios.get(`/api/v1/fs-classification/getCoa/${w_id}`, { headers })
}


export const deletePreset = (preset_id) => {
    return axios.get(`api/v1/project/delete-project/${preset_id}`, {
        headers
    })
}

export const createDuplicate = async (ir_id, userId) => {
    return axios.post(`/api/v1/company-data/duplicateInvest/${ir_id}`, userId, { headers })
}

export const updateProject = async (p_id, data) => {
    return axios.post(`/api/v1/project/update-project/${p_id}`, data, { headers })
}



export const GetLoan = async () => {
    return axios.get(`https://loan.test.api.myfinalyst.com/loan/all?sortBy=createdAt&sort=-1`, { headers })
}

export const GetLease = async () => {
    return axios.get(`${process.env.REACT_APP_LEASE_URL}project/all?sortBy=createdAt&sort=-1`, { headers })
}
export const findLeasesAccount = async (user_id) => {
  return axios.get(`api/v1/superadmin/check-leases-account/${user_id}`);
};

export const createChildUser = async (data) => {
    return axios.post(`/api/v1/auth/create-child-user/`, data, {
        headers
    })
}

export const updateChildUser = async (id, data) => {
    return axios.put(`/api/v1/auth/update-child-user/${id}`, data, {
        headers
    })
}

export const getUserPermission = async (user_id) => {
    return await axios.get(`/api/v1/rolePermission/user-permission/${user_id}`, { headers })
}

export const adminAddUserPermission = async (data) => {
  return await axios.post(`/api/v1/rolePermission/admin/permissions`, data, {
    headers,
  });
};

export const addCompanyToPermission = async (user_id, data) => {
    return await axios.post(`/api/v1/rolePermission/user-permission/company/${user_id}`, data, { headers })
}


export const deleteCompanyFromPermission = async (user_id, company_id) => {
    return await axios.delete(`/api/v1/rolePermission/delete/user-permission/${user_id}/${company_id}`, { headers })
}

export const updateUserPermission = async (user_id, data) => {
    return await axios.put(`/api/v1/rolePermission/user-permission/${user_id}`, data, { headers })
}


export const GetReceivable = async () => {
    return axios.get(`https://receivable.test.api.myfinalyst.com/receivable/all?sortBy=createdAt&sort=-1`, { headers })
}

export const GetPayable = async () => {
    return axios.get(`https://payable.test.api.myfinalyst.com/payable/all?sortBy=createdAt&sort=-1`, { headers })
}

export const GetLogs = async () => {
    return axios.get(`/api/v1/rolePermission/logs`, { headers })
}

export const createLogs = async (data) => {
    return axios.post(`/api/v1/rolePermission/create-logs`, data, {
        headers
    })
}

export const GetSubscriptionPlans = async () => {
    return axios.get(`/api/v1/superadmin/getplan`, { headers })
}

export const GetSubscriptionPlansDetails = async (plan_id) => {
    return axios.get(`/api/v1/superadmin/${plan_id}`, { headers })
}

export const getActivePlan = async () => {
    return axios.get(`/api/v1/payment/get-active-plan`, { headers })
}

export const getAllSubscriptions = async (id) => {
    return axios.get(`/api/v1/payment/get-all-subscriptions?customer_id=${id}`, { headers })
}

export const getSubscriptionById = async (id) => {
    return axios.get(`/api/v1/payment/get-subscription-by-id/${id}`, { headers })
}

export const createSubscriptionInvoice = async (data) => {
    return axios.post(`/api/v1/payment/createInvoice`, data, { headers })
}

export const getInvoiceById = async () => {
    return axios.get(`/api/v1/payment/get-invoice`, { headers })
}

export const createWorkApprover = async (data) => {
    return axios.post('api/v1/workspace/add-work-approver', data, { headers })
}
export const getWorkApprover = async (moduleId, pageName, moduleName) => {
  return axios.get(
    `api/v1/workspace/get-work-approver/?module_id=${moduleId}&page_name=${pageName}&module_name=${moduleName}`,
    { headers }
  );
};
export const getWorkApproverByModulename = async (moduleName) => {
    return axios.get(`api/v1/workspace/get-work-approverbymodulename/?module_name=${moduleName}`, { headers });
}
export const getChildUser = async (parent_id, workspace_id) => {
    return axios.get(`/api/v1/auth/get-child-users/?parent_id=${parent_id}&workspace_id=${workspace_id}`, { headers });
}

export const getCompanyByApproverId = async () => {
    return axios.get(`api/v1/company/get-company-approverid`, { headers })
}

export const getApprovedCompany = async () => {
    return axios.get(`api/v1/company/get-company-approved`, { headers })
}

export const getCompanyByPreparerId = async () => {
    return axios.get(`api/v1/company/get-company-preparerid`, { headers })
}


export const getTicket = async (id) => {
    return axios.get(`api/v1/superadmin-ticket/ticket-contacts/${id}`, { headers })
}

export const createTicket = async (data) => {
    return axios.post(`api/v1/superadmin-ticket/createticket`, data, { headers })
}

export const getTicketById = async (id, data) => {
    return axios.get(`api/v1/superadmin-ticket/${id}`, data, { headers })
}

export const updateTicket = async (id, data) => {
    return axios.put(`api/v1/superadmin-ticket/${id}`, data, { headers })
}

export const postNotes = async (data) => {
    return axios.post(`/api/v1/ticket-note/createnote`, data, { headers })
}

export const getNotes = async (id) => {
    return axios.get(`/api/v1/ticket-note/getnote?ticket_id=${id}`, { headers })
}

export const closeTicketStatus = async (id, data) => {
    return axios.put(`/api/v1/superadmin-ticket/close-status/${id}`, data, { headers })
}

export const reopenTicketStatus = async (id, data) => {
    return axios.put(`/api/v1/superadmin-ticket/reopen/${id}`, data, { headers })
}

export const comanyUpdate = async (data) => {
    return axios.post(`/api/v1/auth/companyUpdate`, data, { headers })
}

export const getcomanyUpdate = async (id) => {
    return axios.get(`/api/v1/auth/getcompanyUpdate?user_id=${id}`, { headers })
}
export const addworkspaceteamMember = async (data) => {
    return axios.post('api/v1/workspace/add-team-member', data, { headers })
}

export const getworkspaceteamMember = async (workspace_id) => {
    return axios.get(`api/v1/workspace/get-team-member?workspace_id=${workspace_id}`, { headers });
}

export const getMemberbyPreparerId = async (parent_id) => {
    return axios.get(`/api/v1/auth/all-member-bypreparer-id?parent_id=${parent_id}`, { headers })
}
export const deleteworkspaceteamMember = async (data) => {
    return axios.put('api/v1/workspace/delete-team-member', data, { headers })
}

export const getAllWorkspacebyUserid = () => {
    return axios.get('/api/v1/workspace/all-workspace-by-userid', { headers })
}

export const addworkspacePermission = async (data) => {
    return axios.post('api/v1/workspace/create-permission', data, { headers })
}

export const getAllWorkspaces = () => {
  return axios.get("api/v1/workspace/get-all-workspace", {
    headers,
  });
};

export const GetAllImportedCompanies = async (user_id) => {
    return axios.get(`api/v1/company/get-all-importedcompany?user_id=${user_id}`, { headers })
}

export const getApprover = async (parent_id) => {
    return axios.get(`/api/v1/auth/get-all-approver/?parent_id=${parent_id}`, { headers });
}

export const getPermission = async (workspace_id) => {
    return axios.get(`/api/v1/workspace/get-permission?workspace_id=${workspace_id}`, { headers });
}

export const addworkspacedraft = async (data) => {
    return axios.post('api/v1/workspace/add-workspace-draft', data, { headers })
}

export const getworkspacedraft = async (workspace_id) => {
    return axios.get(`api/v1/workspace/get-workspace-draft?workspace_id=${workspace_id}`, { headers })
}

export const getTeam = async (data) => {
    return axios.get(`api/v1/superadmin-team/teamdata`, data, { headers })
}
export const getApproverForDeleteCompany = async (parent_id) => {
    return axios.get(`/api/v1/auth/get-approver-delete-company/?parent_id=${parent_id}`, { headers });
}

export const fetchDraftCompany = (c_id) => {
    return axios.get(`api/v1/company/get-draftcompany/${c_id}`, { headers })
}

export const updateDraftCompany = (c_id, data) => {
    return axios.post(`api/v1/company/update-draftcompany/${c_id}`, data, { headers })
}

export const getUserById = async (userId) => {
    return axios.get(`/api/v1/auth/all-user/${userId}`, { headers })
}
export const getApproverForDeleteWorkspace = async (parent_id, workspace_id) => {
    return axios.get(`/api/v1/auth/get-approver-delete-workspace/?parent_id=${parent_id}&workspace_id=${workspace_id}`, { headers });
}

export const checkDeleteAccess = async (workspace_id) => {
    return axios.get(`/api/v1/workspace/check-delete-access/?workspace_id=${workspace_id}`, { headers });
}

export const permittedPreparerIds = async (workspace_id, data) => {
    return axios.post(`/api/v1/workspace/permitted-preparerId/?workspace_id=${workspace_id}`, data, { headers });
}

export const createRequest = async (data) => {
    return axios.post(`/api/v1/workspace/create-request`, data, { headers });
}

export const getRequest = async () => {
    return axios.get(`/api/v1/workspace/get-request`, { headers });
}

export const getOneRequest = async (data) => {
    return axios.post(`/api/v1/workspace/get-one-request`, data, { headers });
}

export const addDeleteDraftWorkspace = async (data) => {
    return axios.post(`/api/v1/workspace/add-delete-workspace-draft`, data, { headers });
}

export const getDeleteWorkspace = async () => {
    return axios.get(`/api/v1/workspace/get-delete-workspace-draft`, { headers });
}

export const getSingleDeleteWorkspacedraft = async (workspace_id) => {
    return axios.get(`api/v1/workspace/get-delete-workspace?workspace_id=${workspace_id}`, { headers })
}

export const getGetDataRegisterLogs = async (moduleName) => {
    return axios.get(`${process.env.REACT_APP_LEASE_URL}dataRegisterLog/get?module=${moduleName}&sortBy=createdAt&sort=-1`, { headers })
}
export const returnDataRegisterLog = async (data, registerId) => {
    return axios.patch(`${process.env.REACT_APP_LEASE_URL}dataRegisterLog/return?id=${registerId}`, data, { headers });
}
export const approveDataRegisterLog = async (registerId) => {
    return axios.patch(`${process.env.REACT_APP_LEASE_URL}dataRegisterLog/approve?id=${registerId}`, {}, { headers });
}

export const GetAllLogs = async () => {
    return axios.get(`/api/v1/logs/get-logs`, { headers })
}

export const getApproverForEditWorkspaces = async (parent_id, data) => {
    return axios.post(`/api/v1/auth/get-approver-edit-workspace/?parent_id=${parent_id}`, data, { headers });
}

export const getPermissionByUid = async (workspace_id, user_id) => {
    return axios.get(`/api/v1/workspace/get-permission-by-uid?workspace_id=${workspace_id}&user_id=${user_id}`, { headers });
}

export const addTeamMemberDraft = async (data) => {
    return axios.post('api/v1/workspace/add-team-member-draft', data, { headers })
}

export const getTeamMemberDraft = async (workspace_id) => {
    return axios.get(`api/v1/workspace/get-draft-teammember?workspace_id=${workspace_id}`, { headers })
}

export const RegisterCompanyData = async (data) => {
    return axios.post('api/v1/company-data/register-company-data', data, { headers })
}
export const CreateCompanyDataIR = async (data) => {
    return axios.post('api/v1/investment-register/create-investment-register', data, { headers })
}
export const GetCompanyDataIR = async (id) => {
    return axios.get(`api/v1/investment-register/get-ir-data?irId=${id}`, { headers })
}
export const CreateNewIRDetails = async (data) => {
    return axios.post('api/v1/investment-register/create-new-ir-detail', data, { headers })
}
export const GetProjectsBasedOnUserId = async (user_id) => {
    return axios.get(`api/v1/investment-register/get-user-id-projects?user_id=${user_id}`, { headers })
}
export const BrowsFs = async (data) => {
    return axios.post('api/v1/investment-register/brows-fs', data, { headers })
}
export const GetConsoleEntryData = async (id, data) => {
    return axios.post(`api/v1/investment-register/get-console-entry-data?detail_id=${id}`, data, { headers })
}

export const addAllOtherOptions = async (data) => {
    return axios.post('api/v1/investment-register/add-other-options', data, { headers })
}

export const getAllOtherOptions = async (otherDatailsId) => {
    return axios.get(`api/v1/investment-register/get-other-options?otherDatailsId=${otherDatailsId}`, { headers })
}

export const getAllOtherDetails = async (otherDatailsId) => {
    return axios.get(`api/v1/investment-register/get-other-details?otherDatailsId=${otherDatailsId}`, { headers })
}

export const addOtherDetails = async (data) => {
    return axios.post('api/v1/investment-register/add-other-details', data, { headers })
}

export const deleteAllOtherDetails = async (data) => {
    return axios.post('api/v1/investment-register/delete-other-options', data, { headers })
}

export const addAllOtherDetails = async (data) => {
    return axios.post('api/v1/investment-register/add-all-other-details', data, { headers })
}

export const saveAllIrDetails = async (data) => {
    return axios.post('api/v1/investment-register/save-ir-details', data, { headers })
}

export const getSingleAllDetails = async (Id) => {
    return axios.get(`api/v1/investment-register/get-single-AllDetailsData?Id=${Id}`, { headers })
}

export const fetchAddinalData = async (id) => {
    return axios.get(`api/v1/investment-register/get-additionalData?id=${id}`, { headers })
}

export const CreateAddinalData = async (data) => {
    return axios.post(`api/v1/investment-register/create-additionalData`, data, { headers })
}

export const BrowsFsAdditional = async (data) => {
    return axios.post('api/v1/investment-register/brows-fs-additional', data, { headers })
}
export const GetConsoleEntryDataAdditional = async (id, data) => {
    return axios.post(`api/v1/investment-register/get-console-entry-data-additional?detail_id=${id}`, data, { headers })
}

export const addAllOtherOptionsAdditional = async (data) => {
    return axios.post('api/v1/investment-register/add-other-options-additional', data, { headers })
}

export const getAllOtherOptionsAdditional = async (otherDatailsId) => {
    return axios.get(`api/v1/investment-register/get-other-options-additional?otherDatailsId=${otherDatailsId}`, { headers })
}

export const getAllOtherDetailsAdditional = async (otherDatailsId) => {
    return axios.get(`api/v1/investment-register/get-other-details-additional?otherDatailsId=${otherDatailsId}`, { headers })
}

export const addOtherDetailsAdditional = async (data) => {
    return axios.post('api/v1/investment-register/add-other-details-additional', data, { headers })
}

export const deleteAllOtherDetailsAdditional = async (data) => {
    return axios.post('api/v1/investment-register/delete-other-options-additional', data, { headers })
}

export const addAllOtherDetailsAdditional = async (data) => {
    return axios.post('api/v1/investment-register/add-all-other-details-additional', data, { headers })
}

export const saveAdditionalIrDetails = async (data) => {
    return axios.post('api/v1/investment-register/save-additional-ir-details', data, { headers })
}

export const deleteOthersDetailsIr = (Ir_id) => {
    return axios.get(`api/v1/investment-register/delete-others-detailsIr?Ir_id=${Ir_id}`, { headers })
}

export const deleteInvestmentRegister = (Ir_id) => {
    return axios.get(`api/v1/investment-register/delete-Ir?Ir_id=${Ir_id}`, { headers })
}

export const renameInvestmentRegister = (Ir_id, data) => {
    return axios.post(`api/v1/investment-register/rename-Ir?Ir_id=${Ir_id}`, data, { headers })
}

export const duplicateInvestmentRegister = (Ir_id) => {
    return axios.get(`api/v1/investment-register/duplicate-Ir?Ir_id=${Ir_id}`, { headers })
}

// export const findLeasesAccount = async (user_id) => {
//     return axios.get(`api/v1/superadmin/check-leases-account/${user_id}`)
// }
// delete Lease api
export const DeleteLease = async (id) => {
    return axios.delete(`${process.env.REACT_APP_LEASE_URL}project/delete?id=${id}`, { headers })
}

// Get all Audit Logs Data
// export const GetAuditLogs =async()=>{
//     return axios.get(`${process.env.REACT_APP_LEASE_URL}auditLog/get?sortField=createdAt&sortOrder=desc&page=1&limit=10`,{headers})
// }

export const GetAuditLogs = async (params = {}) => {
    // Build query string from params object
    const queryParams = new URLSearchParams()

    // Default sorting
    queryParams.append("sortField", "createdAt")
    queryParams.append("sortOrder", "desc")

    // Add all params to query string
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            queryParams.append(key, String(value))
        }
    })

    // Make the API call with the constructed query string
    return axios.get(`${process.env.REACT_APP_LEASE_URL}auditLog/get?${queryParams.toString()}`, { headers })
}

// Export audit logs

export const ExportAuditLogs = async (month, year) => {
    return axios.get(`${process.env.REACT_APP_LEASE_URL}auditLog/export?month=${month}&year=${year}`, { headers, responseType: "blob" })
}

// rename workspace
export const renameWorkspace = async (w_id, data) => {
    return axios.post(`api/v1/workspace/rename-Workspace/${w_id}`, data, { headers })
}



//Create Registers

export const createLeaseRegisterApiHandler = async (data) => {
    return axios.post(`${process.env.REACT_APP_LEASE_URL}project/add`, data, { headers })
}


export const createLoanRegisterApiHandler = async (data) => {
    return axios.post(`${process.env.REACT_APP_LOANS_URL}loan/add`, data, { headers })
}

export const createReceivableRegisterApiHandler = async (data) => {
    return axios.post(`${process.env.REACT_APP_RECEIVABLES_URL}receivable/add`, data, { headers })
}

export const createPayableRegisterApiHandler = async (data) => {
    return axios.post(`${process.env.REACT_APP_PAYABLE_URL}payable/add`, data, { headers })
}

export const createInvestmentRegisterApiHandler = async (data) => {
  return axios.post(
    "api/v1/investment-register/create-investment-register",
    data,
    { headers }
  );
};

export const createSalesRegisterApiHandler = async (data) => {
  return axios.post(`${process.env.REACT_APP_PAYABLE_URL}sale/add`, data, {
    headers,
  });
};

export const createPurchaseRegisterApiHandler = async (data) => {
  return axios.post(`${process.env.REACT_APP_PAYABLE_URL}purchase/add`, data, {
    headers,
  });
};

export const createFixedAssetRegisterApiHandler = async (data) => {
  return axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/add`,
    data,
    {
      headers,
    }
  );
};


// Update Registers
export const editLeaseRegisterApiHandler = async (params, data) => {
    return axios.patch(`${process.env.REACT_APP_LEASE_URL}project/update`, data, { headers, params: { ...params } })
}

// Update Profile
export const updateProfileData = async (data) => {
    return axios.post('api/v1/auth/update-profile', data, { headers })
}

export const getBookClosurePresets = () => {
    return axios.get(`${process.env.REACT_APP_FSCP_URL}bookClosurePreset/workspace-presets`, { headers })
}

// Lease Register

export const getLeaseProjectApiHandler = async (params) => {
    return await axios.get(`${process.env.REACT_APP_LEASE_URL}project/details`, { headers, params: { ...params } })
}

export const getDeletedLeaseRegisters = () => {
    return axios.get(`${process.env.REACT_APP_LEASE_URL}project/all?sortBy=createdAt&sort=-1&deleted=true`, { headers })
}

export const restoreLeaseRegister = (registerID, payload) => {
    return axios.patch(`${process.env.REACT_APP_LEASE_URL}project/restore?id=${registerID}`, payload, { headers })
}
export const softDeleteLeaseRegister = (registerID, payload) => {
  return axios.delete(
    `${process.env.REACT_APP_LEASE_URL}project/delete?id=${registerID}`,
    {
      data: payload,     
      headers
    }
  );
};

export const permanentDeleteLeaseRegister = (registerID, payload) => {
    return axios.delete(`${process.env.REACT_APP_LEASE_URL}project/permanentlyDelete?id=${registerID}`,
    {
      data: payload,     
      headers
    })
}

export const getTemplatesApiHandler = async (params = {}) => {
    return axios.get('/api/v1/groupingTemplate/getAllGroupingTemplate', { headers, params: { ...params } })
}

export const createCustTemplateApiHandler = async (data) => {
    return await axios.post(`/api/v1/groupingTemplate/createGroupingTemplate`, data, { headers })
}

export const getTemplateDetailsApiHandler = async (params) => {
    return await axios.get(`/api/v1/groupingTemplate/getGroupingTemplateDetails`, { headers, params: { ...params } })
}

export const saveGroupingApiHandler = async (params, data) => {
    return await axios.patch(`api/v1/groupingTemplate/saveGrouping`, data, { headers, params: { ...params } })
}

export const updateGroupingApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateGroupingTemplate`, data, { headers, params: { ...params } })
}

export const deleteGroupingTemplateApiHandler = async (params, data) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteGroupingTemplate`, { headers, params: { ...params }, data: data, });
};

export const restoreDelGroupingApiHandler = async (params) => {
    return await axios.put(`/api/v1/groupingTemplate/restoreDeletedGrouping`, {}, { headers, params: { ...params } })
}

export const deleteGroupingApiHandler = async (params, data) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteGrouping`, { headers, params: { ...params }, data: data, });
};

export const createGeneralNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createGeneralNotes`, data, { headers, params: { ...params } })
}

export const createGeneralSubNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubGeneralNotes`, data, { headers, params: { ...params } })
}

export const createBSNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createBSNotes`, data, { headers, params: { ...params } })
}

export const createBSSubNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubBSNotes`, data, { headers, params: { ...params } })
}

export const createPLNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createPLNotes`, data, { headers, params: { ...params } })
}

export const createPLSubNotesApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubBSNotes`, data, { headers, params: { ...params } })
}

export const updateGeneralNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateGeneralNotes`, data, { headers, params: { ...params } })
}

export const updateSubGeneralNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubGeneralNotes`, data, { headers, params: { ...params } })
}


export const deleteGeneralNotesApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteGeneralNotes`, { headers, params: { ...params }, data: data, })
}

export const deleteSubGeneralNotesApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteSubGeneralNotes`, { headers, params: { ...params }, data: data, })
}


export const updateBSNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateBSNotes`, data, { headers, params: { ...params } })
}

export const updateSubBSNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubBSNotes`, data, { headers, params: { ...params } })
}

export const updatePLNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updatePLNotes`, data, { headers, params: { ...params } })
}

export const updateSubPLNotesApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubPLNotes`, data, { headers, params: { ...params } })
}

export const createSocieApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSocie`, data, { headers, params: { ...params } })
}

export const createSubSocieApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubSocie`, data, { headers, params: { ...params } })
}

export const updateSocieApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSocie`, data, { headers, params: { ...params } })
}

export const updateSubSocieApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubSocie`, data, { headers, params: { ...params } })
}

export const createDisclosureApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createDisclosure`, data, { headers, params: { ...params } })
}

export const createSubDisclosureApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubDisclosure`, data, { headers, params: { ...params } })
}

export const updateDisclosureApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateDisclosure`, data, { headers, params: { ...params } })
}

export const deleteDisclosureApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteDisclosure`, { headers, params: { ...params }, data: data, })
}

export const deleteSubDisclosureApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteSubDisclosure`, { headers, params: { ...params }, data: data, })
}

export const updateSubDisclosureApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubDisclosure`, data, { headers, params: { ...params } })
}

export const createCashflowApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createCashflow`, data, { headers, params: { ...params } })
}

export const createSubCashflowApiHandler = async (params, data) => {
    return await axios.post(`/api/v1/groupingTemplate/createSubCashflow`, data, { headers, params: { ...params } })
}

export const updateCashflowApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateCashflow`, data, { headers, params: { ...params } })
}

export const deleteCashflowApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteCashflow`, { headers, params: { ...params }, data: data, })
}

export const deleteSubCashflowApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/groupingTemplate/deleteSubCashflow`, { headers, params: { ...params }, data: data, })
}

export const updateSubCashflowApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/groupingTemplate/updateSubCashflow`, data, { headers, params: { ...params } })
}

export const getPopulateFSDetailsApiHandler = async (params) => {
    return await axios.get(`/api/v1/populateFS/getPopulateFSDetails`, { headers, params: { ...params } })
}

export const getPopulateFSExportFSApiHandler = async (params) => {
    return await axios.get(`/api/v1/populateFS/exportFS`, {
        headers,
        params: { ...params },
        responseType: "blob",
    });
};

export const updatePopulateFSApiHandler = async (params, data) => {
    return await axios.patch(`/api/v1/populateFS/updatePopulateFS`, data, { headers, params: { ...params } })
}

export const deletePopulateFSApiHandler = async (params, data={}) => {
    return await axios.delete(`/api/v1/populateFS/deletePopulateFS`, { headers, params: { ...params }, data: data, })
}

export const GetFixedAsset = async () => {
  return axios.get(
    `https://payable.test.api.myfinalyst.com/fixedAsset/all?sortBy=createdAt&sort=-1`,
    { headers }
  );
};

export const GetSale = async () => {
  return axios.get(
    `https://payable.test.api.myfinalyst.com/sale/all?sortBy=createdAt&sort=-1`,
    { headers }
  );
};

export const GetPurchase = async () => {
  return axios.get(
    `https://payable.test.api.myfinalyst.com/purchase/all?sortBy=createdAt&sort=-1`,
    { headers }
  );
};


export const mapReceivableDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_RECEIVABLES_URL}receivable/mapReceivableDisclosure`, data, { headers, params: { ...params } })
}

export const mapPayableDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_PAYABLE_URL}payable/mapPayableDisclosure`, data, { headers, params: { ...params } })
}

export const mapLoanDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_LOANS_URL}loan/mapLoanDisclosure`, data, { headers, params: { ...params } })
}

export const mapLeaseDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_LEASE_URL}project/mapLeaseDisclosure`, data, { headers, params: { ...params } })
}

export const mapFixedAssetDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_PAYABLE_URL}fixedAsset/mapFixedAssetDisclosure`, data, { headers, params: { ...params } })
}

export const mapSaleDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_PAYABLE_URL}sale/mapSaleDisclosure`, data, { headers, params: { ...params } })
}

export const mapPurchaseDisclosureApiHandler = async (params, data) => {
    return await axios.put(`${process.env.REACT_APP_PAYABLE_URL}purchase/mapPurchaseDisclosure`, data, { headers, params: { ...params } })
}


export const getAllFixedAssetsApiHandler = async () => {
    return await axios.get(`${process.env.REACT_APP_PAYABLE_URL}fixedAsset/all?sortBy=createdAt&sort=-1`, { headers})
}

export const getAllSaleApiHandler = async () => {
    return await axios.get(`${process.env.REACT_APP_PAYABLE_URL}sale/all?sortBy=createdAt&sort=-1`, { headers})
}

export const getAllPurchaseApiHandler = async () => {
    return await axios.get(`${process.env.REACT_APP_PAYABLE_URL}purchase/all?sortBy=createdAt&sort=-1`, { headers})
}

export const getAllLinkedRegistersApiHandler = async (projectID) => {
    return await axios.get(`/api/v1/populateFS/getAllLinkedRegisters?projectID=${projectID}`, { headers })
}
